import React from 'react';

const BackgroundEffects = () => {
    return (
        <div className="background-effects">
            {/* Líneas de escaneo */}
            <div className="scan-lines"></div>

            {/* Partículas flotantes */}
            <div className="floating-particles">
                {Array.from({ length: 20 }).map((_, i) => (
                    <div
                        key={i}
                        className="particle"
                        style={{
                            left: `${Math.random() * 100}%`,
                            animationDelay: `${Math.random() * 5}s`,
                            animationDuration: `${3 + Math.random() * 4}s`
                        }}
                    ></div>
                ))}
            </div>

            {/* Grid sutil de fondo */}
            <div className="cyber-grid"></div>
        </div>
    );
};

export default BackgroundEffects;